import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../App";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Gift, DollarSign, ArrowRight, X } from "lucide-react";

const BecomePartnerBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  // Don't show banner if user is already a referral partner
  if (user?.role === "referral_partner") {
    return null;
  }

  // Check if banner was dismissed in this session
  if (dismissed) {
    return null;
  }

  return (
    <Card className="card-modern bg-gradient-to-r from-rnb-teal/10 to-rnb-blue/10 border-rnb-teal/20 mb-6 relative overflow-hidden" data-testid="become-partner-banner">
      <button
        onClick={() => setDismissed(true)}
        className="absolute top-3 right-3 p-1 text-rnb-gray hover:text-rnb-navy rounded-full hover:bg-white/50 transition-colors"
        aria-label="Dismiss banner"
        data-testid="dismiss-partner-banner"
      >
        <X className="h-4 w-4" />
      </button>
      
      <CardContent className="p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-rnb-teal to-rnb-blue flex items-center justify-center">
              <Gift className="h-6 w-6 text-white" />
            </div>
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="font-heading text-lg font-semibold text-rnb-navy mb-1">
              Earn $150 for Every Referral!
            </h3>
            <p className="text-sm text-rnb-gray">
              Know healthcare professionals who could benefit from our programs? 
              Join our referral program and earn commissions for every successful sign-up.
            </p>
          </div>
          
          <div className="flex-shrink-0 flex items-center gap-3">
            <div className="hidden md:flex items-center gap-1 text-rnb-teal">
              <DollarSign className="h-5 w-5" />
              <span className="text-xl font-bold">150</span>
              <span className="text-xs text-rnb-gray">/referral</span>
            </div>
            
            <Link to="/referral-program/apply">
              <Button className="btn-primary whitespace-nowrap" data-testid="apply-partner-btn">
                Apply Now
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BecomePartnerBanner;
